import { render, staticRenderFns } from "./Pt.vue?vue&type=template&id=44df7cb7&scoped=true&"
import script from "./Pt.vue?vue&type=script&lang=js&"
export * from "./Pt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44df7cb7",
  null
  
)

export default component.exports